<template>
  <div class="flowBackLine">
      <div class="top_line" :style="left_right == 'left' ? topLeft : topRight">
        <template v-if="point == 'top'">
            <div style="pointBox"><span :style="left_right == 'left' ? pointRight : pointLeft"></span></div>
        </template>
      </div>
      <div class="center_line" :style="left_right == 'left' ? centerLeft : centerRight">
            <div style="pointBox"><div class="num">{{index+1}}</div></div>
      </div>
      <div class="bottom_line" :style="left_right == 'left' ? bottomLeft : bottomRight">
        <template v-if="point == 'bottom'">
            <div style="pointBox"><span :style="left_right == 'left' ? pointRight : pointLeft"></span></div>
        </template>
      </div>
  </div>
</template>

<script>
export default {
    props: ["index", "lineData", "startNode"],
    data() {
        return {
            left_right: 'left',
            lineWidth: 0,
            ww: 0,
            hh: 0,
            startX: 0,
            startY: 0,
            startH: 0,
            startW: 0,
            endX: 0,
            endY: 0,
            endH: 0,
            endW: 0,
            point: '',
            screenWidth: document.body.clientWidth,
        }
    },
    methods: {

    },
    computed: {
        topLeft() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.startX - this.startW/2 - Math.abs(this.startX - this.endX) - this.lineWidth - 20}px;top:${this.startY + this.startH/2 - this.hh + 5}px;height: 1px;width:${ Math.abs(this.startX - this.endX) + this.lineWidth }px;background: #00b85c;`
            }else{
                return `position: absolute;left: ${this.endX - this.endW/2 - this.lineWidth - Math.abs(this.startX - this.endX) - 20}px;top:${this.endY + this.endH/2 - this.hh - 5}px;height: 1px;width:${ Math.abs(this.startX - this.endX) + this.lineWidth }px;background: #DA5455;`
            }
        },
        topRight() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.startX + this.startW -this.ww}px;top:${this.startY + this.startH/2 - this.hh - 5}px;height: 1px;width:${ Math.abs(this.startX - this.endX) + this.lineWidth }px;background: #00b85c;`
            }else{
                return  `position: absolute;left: ${this.endX + this.endW -this.ww}px;top:${this.endY + this.endH/2 - this.hh + 5}px;height: 1px;width:${ Math.abs(this.startX - this.endX) + this.lineWidth }px;background: #DA5455;`
            }
        },
        centerLeft() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.endX - this.lineWidth - this.endW/2 - 20}px;top:${this.startY + this.startH/2 - this.hh + 5}px;height: ${Math.abs(this.startY - this.endY)}px;width: 1px;background: #00b85c;`
            }else{
                return  `position: absolute;left: ${this.startX - this.lineWidth - this.startW/2 - 20}px;top:${this.endY + this.endH/2 - this.hh - 5}px;height: ${Math.abs(this.startY - this.endY)}px;width: 1px;background: #DA5455;`
            }
        },
        centerRight() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.endX + this.lineWidth + this.endW -this.ww}px;top:${this.startY + this.startH/2 - this.hh - 5}px;height: ${Math.abs(this.startY - this.endY) + 10}px;width: 1px;background: #00b85c;`
            }else{
                return  `position: absolute;left: ${this.startX + this.lineWidth + this.startW -this.ww}px;top:${this.endY + this.endH/2 - this.hh + 5}px;height: ${Math.abs(this.startY - this.endY) - 10}px;width: 1px;background: #DA5455;`
            }
        },
        bottomLeft() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.endX - this.endW/2 - this.lineWidth - 20}px;top:${this.endY + this.endH/2 - this.hh + 5}px;height: 1px;width:${this.lineWidth}px;background: #00b85c;`
            }else{
                return  `position: absolute;left: ${this.startX - this.startW/2 - this.lineWidth - 20}px;top:${this.startY + this.startH/2 - this.hh - 5}px;height: 1px;width:${this.lineWidth}px;background: #DA5455;`
            }
        },
        bottomRight() {
            if(this.startY < this.endY) {
                return  `position: absolute;left: ${this.endX + this.endW -this.ww}px;top:${this.endY + this.endH/2 - this.hh + 5}px;height: 1px;width:${this.lineWidth}px;background: #00b85c;`
            }else{
                return  `position: absolute;left: ${this.startX + this.startW -this.ww}px;top:${this.startY + this.startH/2 - this.hh - 5}px;height: 1px;width:${this.lineWidth}px;background: #DA5455;`
            }
        },
        pointLeft() {
            if(this.startY < this.endY) {
                return `position: absolute;left:0;top:-5px;width:0;height:0;border-top: 5px solid transparent;border-right: 10px solid #00b85c;border-bottom: 5px solid transparent;`
            }else{
                return `position: absolute;left:0;top:-5px;width:0;height:0;border-top: 5px solid transparent;border-right: 10px solid #DA5455;border-bottom: 5px solid transparent;`
            }
        },
        pointRight() {
            if(this.startY < this.endY) {
                return `position: absolute;right:0;top:-5px;width:0;height:0;border-top: 5px solid transparent;border-left: 10px solid #00b85c;border-bottom: 5px solid transparent;`
            }else{
                return `position: absolute;right:0;top:-5px;width:0;height:0;border-top: 5px solid transparent;border-left: 10px solid #DA5455;border-bottom: 5px solid transparent;`
            }
        }
    },
    mounted() {
        this.point = "";
        this.lineWidth = 30 + 15*(this.index + 1);
        // 判断节点左右
        if(this.lineData.processSourceOrigin.X >= this.startNode.X && this.lineData.processTargetOrigin.X >= this.startNode.X) {
            this.left_right = 'right';
        }else{
            this.left_right = 'left';
        }
        // 判断开始节点在上面还是下面
        if(this.lineData.processSourceOrigin.Y > this.lineData.processTargetOrigin.Y) {
            this.point =  'top';
        }else{
            this.point =  'bottom';
        }
        this.ww = document.body.clientWidth*0.05 + 3;
        this.hh = document.body.clientHeight*0.15;
        
        // 节点位置
        this.startX = this.lineData.processSourceOrigin.X;
        this.startY = this.lineData.processSourceOrigin.Y;
        this.startH = this.lineData.processSourceOrigin.H;
        this.startW = this.lineData.processSourceOrigin.W;
        this.endX = this.lineData.processTargetOrigin.X;
        this.endY = this.lineData.processTargetOrigin.Y;
        this.endH = this.lineData.processTargetOrigin.H;
        this.endW = this.lineData.processTargetOrigin.W;

        // 监听窗口变化
        window.onresize = () => (() => {
            window.screenWidth = document.body.clientWidth;
            this.screenWidth = window.screenWidth;
        })();
    },
    watch: {
        screenWidth(val) {
            if (!this.timer) {
                this.screenWidth = val;
                this.ww = val*0.05 + 3;
                this.hh = document.body.clientHeight*0.15;
                this.timer = true;
                const that = this;
                setTimeout(function () {
                    that.timer = false;
                }, 10);
            }
        }
    }
}
</script>

<style scoped lang="scss">
.pointBox{
    width: 100%;
    height: 100%;
    position: relative;
}
.num{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1.2px solid #777;
    background-color: #fff;
    z-index: 99;
}
</style>